$(document).ready(function () {
    $(document).on("click", "#submit_contact_us", function () {
        newContactUs($("#contact_us_form"), "save_contact_us");
    });
});

function newContactUs(form, operation) {
    let name = $("#user_name");
    let email = $("#user_email");
    let mobile = $("#user_mobile");
    let message = $("#user_message");

    let valid = true;
    let errors = [];

    if (!name.val().length) {
        valid = false;
        errors.push("Please provide name");
        // showValidationError(name, "Please provide name");
    }

    if (!mobile.val().length) {
        valid = false;
        errors.push("Please provide contact no");
        // showValidationError(mobile, "Please provide contact no");
    }

    if (email.val().length) {
        if (isValidEmail(email)) {
            removeValidation(email);
        } else {
            valid = false;
            errors.push("Please enter valid email address");
            // showValidationError(email, "Please enter valid email address");
        }
    }

    name = name.val().trim();
    email = email.val().trim();
    mobile = mobile.val().trim();
    message = message.val().trim();

    if (!valid) {
        showAlert({
            "type": "error",
            "message": errors.join("<br>")
        });
        // showFormError();
    } else {
        let data = {
            operation: operation,
            name: name,
            email: email,
            mobile: mobile,
            message: message
        };

        if (operation === "book_appointment") {
            let date = getFormattedDate(
                {
                    date: convertJSDatetoPHPDate(selected_date),
                    format: ["yyyy", "-", "mm", "-", "dd"]
                });

            if (selected_am === "PM") {
                selected_hour = 12 + removeLeadingZeros(selected_hour);
            }

            data["date"] = date + " " + selected_hour + ":" + selected_minute + ":00";
        }

        $.ajax({
            url: "../classes/contact_us.php",
            beforeSend: function () {
            },
            data: data,
            type: "POST",
            success: function (response) {
                let json_ob = parseJSON(response);
                if (json_ob !== false) {
                    showAlert(json_ob);
                }
            },
            error: function (response) {
                showAJAXError(response);
            }
        });
    }
}